module.exports = "<tf-market-movers type=\"top200\" on-click=\"ctrl.moverClicked(mover)\">\n\n</tf-market-movers>";